module.exports = __webpack_public_path__ + "static/github-f352e4dda6f4be59033d73eada1091b4.svg";